import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

const SidebarBranding = ({ children, className }) => {
  const classes = classNames({
    'pro-wrapper-sidebar-branding': true,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <div className="pro-wrapper-sidebar-pad">{children}</div>
    </div>
  );
};

SidebarBranding.propTypes = propTypes;

export default SidebarBranding;
